import React from 'react'

import HeaderMobile from './HeaderMobile'
import Logo from './Logo'

function Header() {
    return (
        <header id='header'>
            <div className='not-mobile'>
                <h1 className='logo'>
                    <a href='/'>
            <span className='logo-content' tabIndex='-1'>
              <Logo/>
            </span>
                    </a>
                </h1>
                <div>
                    <a href="https://dev.mvnhub.ir" target="_blank" className="navbar-brand">
                        <span>Hosted with ♥️ By ‌</span>
                        <img src="https://mvnhub.ir/assets/logo.png" alt="M" className="logo-m"
                             style={{width: 2.5 + 'rem', height: 2.5 + 'rem', margin: -4 + 'px'}}/>
                        <span>vnHub</span>
                    </a>
                </div>
            </div>
            <HeaderMobile/>
        </header>
    )
}

export default Header
